export const helpEmail = 'support@headlamp.com';

export const fallbackMessage = `Something went wrong. Please contact us at ${helpEmail} for assistance.`;

export const ErrorCodes = {
  addPatient: {
    apiError: 'API-AP-001: Error Saving Patient',
  },
};
